import { Base } from '@gate31/core/src/libs/BaseComponent';

export class TableSizeTriggerDesk extends Base<HTMLDivElement> {
    static cn = new Base.BuildCn('TableSizeTriggerDesk');

    constructor(node: HTMLDivElement) {
        super(node);
    }
}
